exports.locales = {
  en: 'English',
  de: 'Deutsch',
};

exports.buildLocales = ['en'];

exports.defaultLocale = 'en';
